import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js';

const parsePhone = (phoneNumber: string, cb: (parsedPhone: PhoneNumber) => string) => {
    const parsedPhone = parsePhoneNumber(phoneNumber, {
        defaultCountry: 'US',
    });

    return parsedPhone ? cb(parsedPhone) : '';
};

export const getCommonPhoneFormat = (phoneNumber: string) =>
    parsePhone(phoneNumber, (parsedPhone) => {
        return `+${parsedPhone.countryCallingCode} ${parsedPhone.formatNational()}`;
    });

export const getCommonPhoneFormatURI = (phoneNumber: string) =>
    parsePhone(phoneNumber, (parsedPhone) => parsedPhone.getURI());
